'use strict';

const rateLimit = require('./rateLimit');

module.exports = {
  rateLimit,
};
